import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "twf_admin_token";
export const adminToken = {
  get: () => localStorage.getItem(ADMIN_TOKEN_KEY) || "",
  set: (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t),
  clear: () => localStorage.removeItem(ADMIN_TOKEN_KEY),
};

const client = axios.create({ baseURL: API });

// Attach the admin session token when present (backend only enforces it on /admin routes).
client.interceptors.request.use((config) => {
  const t = adminToken.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const api = {
  framework: () => client.get(`/framework`).then((r) => r.data),
  questions: (pathway) => client.get(`/questions/${pathway}`).then((r) => r.data),
  createRespondent: (payload) => client.post(`/respondents`, payload).then((r) => r.data),
  getRespondent: (id) => client.get(`/respondents/${id}`).then((r) => r.data),
  submitAnswers: (id, answers) =>
    client.put(`/respondents/${id}/answers`, { answers }).then((r) => r.data),
  getResults: (id) => client.get(`/respondents/${id}/results`).then((r) => r.data),
  getResultsByToken: (token) => client.get(`/results/token/${token}`).then((r) => r.data),
  sendResults: (id, payload) =>
    client.post(`/respondents/${id}/send-results`, payload).then((r) => r.data),
  captureLead: (id, payload) => client.post(`/respondents/${id}/lead`, payload).then((r) => r.data),
  inviteCounterpart: (id, payload) =>
    client.post(`/respondents/${id}/counterpart`, payload).then((r) => r.data),
  adminStats: () => client.get(`/admin/stats`).then((r) => r.data),
  adminList: (params) => client.get(`/admin/respondents`, { params }).then((r) => r.data),
  adminDetail: (id) => client.get(`/admin/respondents/${id}`).then((r) => r.data),
  adminHubspotSync: (id) =>
    client.post(`/admin/respondents/${id}/hubspot-sync`).then((r) => r.data),
  adminJourneySync: (id) =>
    client.post(`/admin/respondents/${id}/journey-sync`).then((r) => r.data),
  goDeeper: (id) => client.post(`/respondents/${id}/go-deeper`).then((r) => r.data),
  adminLogin: (payload) => client.post(`/admin/login`, payload).then((r) => r.data),
  adminMe: () => client.get(`/admin/me`).then((r) => r.data),
  adminLogout: () => client.post(`/admin/logout`).then((r) => r.data),
};
